export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  // that.$l('table_label_userLoanRequestNo') ||
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'defaultImageUrl',
    width: 120,
    align: 'center',
    headerAlign: 'center',
    slots: { default: 'defaultImageUrl' }
  },
  {
    title: that.$l('table_label_fabric') || '面料',
    field: 'fabricName',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'fabricName' },
  },
  {
    title: that.$l('table_label_fabric_weight_and_wid') || '克重/门幅',
    field: 'widAndWeight',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    slots: { default: 'widAndWeight' }
  },
  {
    title: that.$l('INDEX.form_label_color') || '颜色',
    field: 'fabricColor',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    slots: { default: 'fabricColor' }
  },
  {
    title: that.$l('table_label_fabric_factory') || '面料工厂',
    field: 'fabricScm',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    slots: { default: 'fabricScm' }
  },

  {
    title: that.$l('INDEX.Status') || '状态',
    field: 'status',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: {
      default: 'status'
    }
  },
  {
    title: that.$l('table_label_quantity_unit_price') || '数量单价',
    field: 'unitPrice',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    slots: { default: 'unitPrice' }
  },
  {
    title: that.$l('table_label_demand_amount') || '金额',
    field: 'demandAmount',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    slots: { default: 'demandAmount' }
  },
  {
    title: that.$l('table_label_fabric_demand_no') || '需求单号',
    field: 'resFabricDemandNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    slots: { default: 'resFabricDemandNo' }
  },


]
